import { useOrderScanAdd } from "hooks/order-scan/useOrderScan";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useToasts } from "react-toast-notifications";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

const BarcodeScannerAddModal = props => {
  const { handleOpenAddBarcodeModal, isSendOrder } = props;

  const { addToast } = useToasts();

  const [isOpenModalAdd, setIsOpenModalAdd] = useState(false);
  const toggleModalAdd = () => {
    handleOpenAddBarcodeModal && handleOpenAddBarcodeModal(!isOpenModalAdd);
    setIsOpenModalAdd(!isOpenModalAdd);
  };
  const [errorAdd, setErrorAdd] = useState(null);

  const { mutate: mutateOrderScanAdd } = useOrderScanAdd({
    onSuccess: data => {
      setErrorAdd(null);
      // toggleModalAdd();
    },
    onError: ({ errorMessage, code }) => {
      setErrorAdd(`${errorMessage} (Mã: ${code})`);
    },
  });

  const inputSearch = useRef(null);

  const handleKeyDown = event => {
    if (event.key === "Enter") {
      mutateOrderScanAdd({
        isSendOrder: isSendOrder,
        code: inputSearch.current.value,
      });
      inputSearch.current.value = "";
      inputSearch?.current?.focus();
      // Enter key is pressed
      // Perform your desired action here
      // toggleModal();
    }
  };

  useEffect(() => {
    if (isOpenModalAdd) {
      setErrorAdd(null);
      inputSearch?.current?.focus();
      const intervalId = setInterval(() => {
        inputSearch?.current?.focus();
      }, 500);
      return () => {
        clearInterval(intervalId);
      };
    }
  }, [isOpenModalAdd]);

  return (
    <div>
      <Button
        type="button"
        color="primary"
        className="me-2 btn-label"
        onClick={toggleModalAdd}
      >
        <i className="fas fa-plus label-icon" />
        Thêm kiện
      </Button>
      <Modal
        size="lg"
        isOpen={isOpenModalAdd}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModalAdd}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModalAdd}>Thêm kiện</ModalHeader>
          <ModalBody>
            <div className="search-box mb-md-2 me-2 d-inline-block flex-grow-1">
              <div className="position-relative">
                <input
                  style={{ width: "30vw", minWidth: "276px" }}
                  ref={inputSearch}
                  // value={searchTerm}
                  type="search"
                  onKeyDown={handleKeyDown}
                  className="form-control"
                  placeholder="Nhập Barcode. Enter để thêm mới"
                />
                <i
                  className="bx bxs-barcode search-icon"
                  style={{ color: "#50a5f1" }}
                />
              </div>
              {errorAdd && (
                <div
                  className="text-danger font-size-17"
                  style={{ fontStyle: "italic" }}
                >
                  {errorAdd}
                </div>
              )}
            </div>
          </ModalBody>
        </div>
      </Modal>
    </div>
  );
};

BarcodeScannerAddModal.propTypes = {
  handleOpenAddBarcodeModal: PropTypes.any,
  isSendOrder: PropTypes.bool,
};

export default BarcodeScannerAddModal;
